import { render, staticRenderFns } from "./PoliciesOverYN.vue?vue&type=template&id=3b8ee86f"
import script from "./PoliciesOverYN.vue?vue&type=script&lang=js"
export * from "./PoliciesOverYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports